import type {ExpressionElement} from '@packages/systems/wfdl-ast';
import {
  getChildren,
  isOptimizationBaseElement,
} from '@packages/utilities/platform';
import {isMatchingVariation} from './isMatchingVariation';

export function getMatchingVariationChild(
  experienceElement: ExpressionElement,
  variationId: string | null
) {
  const children = getChildren(experienceElement) || [];
  let base: ExpressionElement | null = null;

  for (const child of children) {
    if (isMatchingVariation(child, variationId)) {
      return child;
    }

    if (isOptimizationBaseElement(child)) {
      base = child;
    }
  }

  return base;
}
